__turbopack_context__.v({
  "bottom-center": "styles-module__FQp8nW__bottom-center",
  "container": "styles-module__FQp8nW__container",
  "image": "styles-module__FQp8nW__image",
  "label": "styles-module__FQp8nW__label",
  "labelOverlay": "styles-module__FQp8nW__labelOverlay",
  "picture": "styles-module__FQp8nW__picture",
  "top-left": "styles-module__FQp8nW__top-left",
});
